export function initObf() {
  window.btnToA = function (obj, url) {
    const link = document.createElement('a');
    link.href = url;

    Array.from(obj.attributes).forEach(attr => {
      if (attr.name !== 'onmouseover' && attr.name !== 'onclick') {
        link.setAttribute(attr.name, attr.value);
      }
    });

    link.innerHTML = obj.innerHTML;

    obj.replaceWith(link);
  };
}
